import React from 'react';
import {IconButtonTypes} from "./IconButton.types";
import clsx from "clsx";

export const IconButton: React.FC<IconButtonTypes> = (props) => {
    const {disabled = false} = props;
    return (
        <button
            id={props.id}
            className={clsx(props.className)}
            onClick={props.onClick}
            disabled={disabled}
            style={props.style}
        >
            {props.children}
        </button>
    )
}
